<form [formGroup]="loginForm">
    <h1 mat-dialog-title>{{title}}</h1>
    <p [innerHTML]="message | safeHTML"></p>
    <div fxLayout="column" fxLayoutAlign="start stretch">
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div>Username:</div>
            <mat-form-field appearance="outline">
                <input matInput type="text" name="username" formControlName="username" required />
            </mat-form-field>
        </div>
        <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
            <div>Password:</div>
            <mat-form-field appearance="outline">
                <input
                    matInput
                    type="password"
                    name="password"
                    formControlName="password"
                    #password="matInput"
                    required
                    cdkFocusInitial="true"
                />
            </mat-form-field>
        </div>
    </div>
    <div *ngIf="CancelTried" class="cancelwarning">
        <strong><span>Note: </span></strong>If you cancel this reauthentication request, your session to Journey will be logged out and
        you cannot continue. Any unsaved changes on the current page
        <strong
            ><em><u>will</u></em></strong
        >
        be lost. Click the "Cancel" button again to logout from the Journey System.
    </div>
    <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px">
        <button mat-raised-button type="button" color="warn" (click)="CancelHandler()">{{canceltext}}</button>
        <button mat-raised-button type="submit" color="primary" (click)="OKHandler()" [disabled]="!loginForm.valid">{{oktext}}</button>
    </div>
</form>
